module.exports = "<router-outlet></router-outlet>\n<app-popup-message></app-popup-message>"